import DocumentComponent from "../components/Document.component";
import BannerComponent from "../components/Banner.component";
import i18n from "../i18n";
import {Container} from "react-bootstrap";
import ScheduleComponent from "../components/Schedule.component";
import AwardsComponent from "../components/Awards.component";

export default function Awards() {

    const {t} = i18n;

    return (
        <>
            <DocumentComponent title={t('Awards')}/>
            <BannerComponent title={t('Awards')} description={''}/>
            <Container className="mb-5 galleryContainer">
                <AwardsComponent/>
            </Container>

            <ScheduleComponent/>
        </>
    );
}
